export const environment = {
    production: false,
    apiUrl: 'https://gateway.dev.takenote.cloud/flight-centre-au',
    productId: 'DFDS-Demo',
    productType: 'DFN'
};